import React from "react";
import {
    Coffee,
    Hammer,
    ShoppingBag,
    Sparkles,
    Scissors,
    Camera,
    Palette,
    Heart,
    Store,
    Flower2,
    Dumbbell,
    BookOpen,
} from "lucide-react";

const industries = [
    { icon: Coffee, label: "Cafés & Eateries" },
    { icon: Hammer, label: "Trades & Builders" },
    { icon: ShoppingBag, label: "DTC & Online Stores" },
    { icon: Sparkles, label: "Wellness & Beauty" },
    { icon: Scissors, label: "Salons & Spas" },
    { icon: Camera, label: "Creatives & Studios" },
    { icon: Palette, label: "Artists & Makers" },
    { icon: Heart, label: "Coaches & Therapists" },
    { icon: Store, label: "Bricks & Mortar Retail" },
    { icon: Flower2, label: "Florists & Plant Shops" },
    { icon: Dumbbell, label: "Gyms & Studios" },
    { icon: BookOpen, label: "Educators & Authors" },
];

export default function WhoWeWorkWith() {
    return (
        <section
            id="who"
            className="relative border-b border-hairline bg-oat py-24 lg:py-36"
            data-testid="who-section"
        >
            <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
                <div className="mb-12 max-w-3xl">
                    <div className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-coral">
                        // Chapter 03 · Who we work with
                    </div>
                    <h2 className="font-display text-5xl font-black leading-[0.95] tracking-tight text-ink sm:text-6xl lg:text-7xl">
                        Small businesses,{" "}
                        <span className="font-serif italic font-normal text-coral">
                            of every flavour.
                        </span>
                    </h2>
                    <p className="mt-6 max-w-2xl text-sm leading-relaxed text-ink/70 lg:text-base">
                        Cafés, builders, boutiques, coaches, makers, salons, studios — anyone with
                        1–50 staff who&apos;d rather run the shop than the algorithm. If you don&apos;t see
                        your industry, that just means we haven&apos;t added it yet — we&apos;d love to chat.
                    </p>
                </div>

                <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 lg:gap-4">
                    {industries.map((it, i) => {
                        const Icon = it.icon;
                        return (
                            <div
                                key={it.label}
                                className={`group flex items-center gap-3 border-2 border-ink/25 bg-oat p-4 transition-all hover:-translate-y-0.5 hover:border-ink lg:p-5 ${
                                    i % 5 === 0 ? "hover:frame-coral" : i % 5 === 2 ? "hover:frame-sun" : "hover:frame"
                                }`}
                                data-testid={`industry-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            >
                                <div className="grid h-9 w-9 shrink-0 place-items-center border-2 border-ink text-ink group-hover:bg-coral group-hover:text-ink">
                                    <Icon className="h-4 w-4" />
                                </div>
                                <span className="font-display text-sm font-bold uppercase tracking-tight text-ink lg:text-base">
                                    {it.label}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
